<div class="starter-container">
    <h3>Don't know how to begin? Use conversation starter</h3>
    <p *ngIf="question.length > 0">{{question}}</p>
    <div class="buttons container">
        <button mdbBtn mdbWavesEffect (click)="getQuestion()" color="blue" class="btn btn-sm">{{question.length > 0 ? "Change question" : "Get question"}}</button>
        <button *ngIf="question.length > 0" mdbBtn mdbWavesEffect (click)="onClickStart($event)" color="blue" class="btn btn-sm ">Start</button>
    </div>
</div>